import React from "react";
import { Popover } from "antd";

const scale = [0.0001, 0.001, 0.01, 0.1, 1, 5, 10, 100];

class Frequency extends React.Component {
  render() {
    const closest = scale.reduce((prev, curr) =>
      Math.abs(curr - this.props.value) < Math.abs(prev - this.props.value)
        ? curr
        : prev
    );

    const popover = (
      <div className="frequency__max">
        <div className="frequency__preview">
          <img src="/img/drop.svg" alt="" />
        </div>
        <div className="frequency__label label">Max Recessive</div>
        <div className="frequency__value">{this.props.value + "%"}</div>
      </div>
    );

    // const { value } = this.props;

    return (
      <div className="frequency">
        <div className="frequency__scale">
          {scale.map((x, i) => (
            <div className="frequency__cell" key={i}>
              {scale[i + 1] === closest && (
                <div
                  className="frequency__value"
                  style={{ left: (100 * this.props.value) / closest + "%" }}
                >
                  <div className="frequency__drop">
                    <Popover placement="bottom" content={popover}>
                      <div className="frequency__preview">
                        <img
                          className="frequency__pic"
                          src="/img/drop.svg"
                          alt=""
                        />
                      </div>
                    </Popover>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
        <div className="frequency__pips">
          {scale.map((x, i) => (
            <div className="frequency__pip label" key={i}>
              {x + "%"}
            </div>
          ))}
        </div>
        <div className="frequency__borders">
          <div className="frequency__border label">Rare</div>
          <div className="frequency__border label">Common</div>
        </div>
      </div>
    );
  }
}

export default Frequency;
